import React from "react";

export default function Imprint() {
  return (
    <div
      className="min-h-screen bg-black text-white"
      style={{ fontFamily: "Inter, sans-serif" }}
    >
      <div
        className="max-w-3xl mx-auto px-6"
        style={{
          paddingTop: "clamp(80px, 12vw, 200px)",
          paddingBottom: "120px",
        }}
      >
        <h1
          style={{
            fontFamily: "Archivo, sans-serif",
            fontVariationSettings: '"wght" 600, "wdth" 75',
            fontSize: "clamp(48px, 8vw, 96px)",
            letterSpacing: "-0.02em",
            lineHeight: "0.9",
            marginBottom: "80px",
            textTransform: "uppercase",
          }}
        >
          IMPRINT
        </h1>

        <div style={{ fontSize: "16px", lineHeight: "1.8", color: "#a1a1aa" }}>

          <section style={{ marginBottom: "56px" }}>
            <h2 style={{ fontFamily: "Archivo, sans-serif", fontVariationSettings: '"wdth" 80, "wght" 700', fontSize: "11px", letterSpacing: "0.12em", textTransform: "uppercase", color: "#ffffff", marginBottom: "16px" }}>
              Information according to § 5 DDG
            </h2>
            <p>
              René Gebhardt<br />
              Freelance Art Director<br />
              Weserstr. 75<br />
              12059 Berlin<br />
              Germany
            </p>
          </section>

          <section style={{ marginBottom: "56px" }}>
            <h2 style={{ fontFamily: "Archivo, sans-serif", fontVariationSettings: '"wdth" 80, "wght" 700', fontSize: "11px", letterSpacing: "0.12em", textTransform: "uppercase", color: "#ffffff", marginBottom: "16px" }}>
              Contact
            </h2>
            <p>
              Phone: +49 176 20 19 18 26<br />
              Email: mail@rene-gebhardt.com<br />
              Website: www.rene-gebhardt.com
            </p>
          </section>

          <section style={{ marginBottom: "56px" }}>
            <h2 style={{ fontFamily: "Archivo, sans-serif", fontVariationSettings: '"wdth" 80, "wght" 700', fontSize: "11px", letterSpacing: "0.12em", textTransform: "uppercase", color: "#ffffff", marginBottom: "16px" }}>
              Responsible for content according to § 18 Abs. 2 MStV
            </h2>
            <p>
              René Gebhardt<br />
              Weserstr. 75<br />
              12059 Berlin<br />
              Germany
            </p>
          </section>

          <section style={{ marginBottom: "56px" }}>
            <h2 style={{ fontFamily: "Archivo, sans-serif", fontVariationSettings: '"wdth" 80, "wght" 700', fontSize: "11px", letterSpacing: "0.12em", textTransform: "uppercase", color: "#ffffff", marginBottom: "16px" }}>
              VAT ID according to §27a Umsatzsteuergesetz
            </h2>
            <p>DE 297608728</p>
          </section>

          <section style={{ marginBottom: "56px" }}>
            <h2 style={{ fontFamily: "Archivo, sans-serif", fontVariationSettings: '"wdth" 80, "wght" 700', fontSize: "11px", letterSpacing: "0.12em", textTransform: "uppercase", color: "#ffffff", marginBottom: "16px" }}>
              EU Dispute Resolution
            </h2>
            <p>
              The European Commission provides a platform for online dispute resolution (ODR):{" "}
              <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" style={{ color: "#ffffff", textDecoration: "underline" }}>
                ec.europa.eu/consumers/odr
              </a>
            </p>
            <p style={{ marginTop: "16px" }}>
              We are not willing or obliged to participate in dispute resolution proceedings before a consumer arbitration board.
            </p>
          </section>

          <section style={{ marginBottom: "56px" }}>
            <h2 style={{ fontFamily: "Archivo, sans-serif", fontVariationSettings: '"wdth" 80, "wght" 700', fontSize: "11px", letterSpacing: "0.12em", textTransform: "uppercase", color: "#ffffff", marginBottom: "16px" }}>
              Liability for Content
            </h2>
            <p>
              The contents of our pages have been created with the utmost care. However, we cannot guarantee the accuracy, completeness or timeliness of the content.
            </p>
          </section>

          <section style={{ marginBottom: "56px" }}>
            <h2 style={{ fontFamily: "Archivo, sans-serif", fontVariationSettings: '"wdth" 80, "wght" 700', fontSize: "11px", letterSpacing: "0.12em", textTransform: "uppercase", color: "#ffffff", marginBottom: "16px" }}>
              Liability for Links
            </h2>
            <p>
              Our website contains links to external third-party websites. We have no influence on the contents of those websites and therefore cannot accept liability for them.
            </p>
          </section>

          <section>
            <h2 style={{ fontFamily: "Archivo, sans-serif", fontVariationSettings: '"wdth" 80, "wght" 700', fontSize: "11px", letterSpacing: "0.12em", textTransform: "uppercase", color: "#ffffff", marginBottom: "16px" }}>
              Copyright
            </h2>
            <p>
              The content and works created by the site operator on these pages are subject to German copyright law. Any reproduction, editing or distribution requires written permission from the respective author.
            </p>
          </section>

        </div>
      </div>
    </div>
  );
}